/**
 * PostHog Integration
 * Handles product analytics and feature flags.
 */

import posthog from 'posthog-js';

export const initPostHog = () => {
    const token = import.meta.env.VITE_POSTHOG_TOKEN;
    const apiHost = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com';
    const environment = import.meta.env.VITE_APP_ENV || 'development';

    if (!token) {
        if (environment === 'production') {
            console.warn('PostHog token not found in production environment.');
        }
        return;
    }

    posthog.init(token, {
        api_host: apiHost,
        autocapture: true,
        capture_pageview: true,
        persistence: 'localStorage',
        property_blacklist: ['$ip'], // Basic privacy protection
    });
};

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    posthog.capture(eventName, properties);
};

export const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
    posthog.identify(userId, properties);
};

export const resetUser = () => {
    posthog.reset();
};
